import React from "react";
import { Link } from "../../utils/customLink";
import SubNavMenu from "../shared/subNavMenu";
import { useTheme } from "../../context/ThemeContext";

const MenuLocations = ({ menuItems, children }) => {
  const { peopleDomain, planetDomain, currentBrand } = useTheme();

  const secondarySiteUrl = currentBrand.includes("people")
    ? planetDomain
    : peopleDomain;

  const locationsText = currentBrand.includes("people")
    ? "To view our conservation locations"
    : "To view our community development locations";

  return (
    <>
      <section className="bg-yellow-lighter planet:bg-gray-darker fixed w-full top-16 z-10 flex justify-center py-10 h-100 md:overflow-y-scroll lg:overflow-y-hidden">
        <div className="container flex w-10/12 flex-wrap lg:flex-nowrap">
          <div className="w-full border-l-0 mr-12 md:w-9/12 overflow-y-auto xxs:max-h-[800px]">
            <div className="w-full gvi-dark-gray-color border-b pb-3 border-border-light planet:border-gray-lighter">
              <span className="h5 uppercase text-white active-link !px-0 pb-3">
                Locations
              </span>
            </div>
            <div className="w-full flex sm:flex-col mt-8">
              <div
                className={`pr-4 flex flex-col md:grid  gap-4 w-full ${[
                  "md:grid-cols",
                  menuItems?.length || 4
                ].join("-")}`}
              >
                {menuItems?.map((menu, idx) => {
                  return (
                    <SubNavMenu
                      subTitle={menu.label}
                      countryCount={menu?.children?.length}
                      subtitleLink={menu.path ?? menu.url}
                      subTitleClass={menu?.description}
                      className={`${menu?.cssClasses.join(" ")} ${
                        idx > 0 ? "" : ""
                      }`}
                      data={menu?.children?.nodes ?? menu?.children}
                      key={idx}
                    />
                  );
                })}
              </div>
              <div className="w-9/12 border-l-0 mr-12 lg:w-9/12 hidden">
                &nbsp;
              </div>
              <div className="flex w-full pt-12 text-black-lighter planet:text-white text-base font-light">
                {locationsText},{"  "}
                <Link
                  to={`${secondarySiteUrl}?nav_switcher=1`}
                  className="font-bold pl-1 hover:text-white"
                >
                  click here
                </Link>
              </div>
            </div>
          </div>

          <div className="w-full pb-16 pt-4 lg:w-3/12 lg:pt-0">{children}</div>
        </div>
      </section>
    </>
  );
};

export default MenuLocations;
